import React from 'react';

import { appMethod as app } from '@utils/app';
import { Carousel } from 'antd-mobile';
import { convertStyleData, transformPx2Rem } from '@utils/tools';

import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';
import { RequestStatus } from 'src/common/request-status/RequestStatus';
import { LoadingBtn } from 'src/common/loading-btn/LoadingBtn';

import './VideoListCustomComponent.less';

/**
 * type: 'video-list'
 * 组件：视频列表组件
 */
export default class VideoListCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    const compindex = props.index;
    const pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    let param = {};
    let compData = pageInstance.data.eles[compindex];
    let customFeature = compData.customFeature;
    let newdata = {};
    
    var isClassify = false;
    if (app.getInvolvedFromRefreshObject(customFeature.id, 'new-classify')) {
      isClassify = true;
    }
    if (isClassify){
      return;
    }
    
    param.form = "video";
    param.page_size = customFeature.loadingNum || 10;
    param.page = 1;
    if (customFeature.source && customFeature.source != 'none'){
      param.cate_id = customFeature.source;
    }

    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].video_data'] = [];
    newdata['eles[' + compindex + '].is_more'] = 1;
    newdata['eles[' + compindex + '].curpage'] = 0;
    newdata['eles[' + compindex + '].param'] = param;
    pageInstance.setData(newdata);

    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppVideo/GetVideoList',
      data: param,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        if (res.status == 0) {
          let rdata = res.data,
              newdata = {};

          for (let i = 0; i < rdata.length; i++) {
            rdata[i].video_view = app.handlingNumber(rdata[i].video_view);
          }

          newdata['eles[' + compindex + '].video_data'] = rdata;

          newdata['eles[' + compindex + '].is_more'] = res.is_more;
          newdata['eles[' + compindex + '].curpage'] = 1;
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;

          pageInstance.setData(newdata);
        }
      },
      fail: function (res) {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  }

  videoScrollFunc = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex       = typeof event == 'object' ? event.currentTarget.dataset.compindex : event;
    let compData     = pageInstance.data.eles[compindex];

    if(compData.is_search){
      // 与搜索组件相关联
      let searchComponentIndex = compData.searchEle;
      pageInstance.callComponentMethod({
        componentIndex: searchComponentIndex,
        methodName: 'searchList',
        argvs: [searchComponentIndex, event]
      });
    }else{
      this._videoScrollFunc(event);
    }
  }

  _videoScrollFunc = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex       = typeof event == 'object' ? event.currentTarget.dataset.compindex : event;
    let compData     = pageInstance.data.eles[compindex];
    let curpage      = compData.curpage + 1;
    let customFeature = compData.customFeature;
    let newdata      = {};
    let param = compData.param || {};

    if(!compData.is_more && typeof event == 'object' && event.type == 'tap'){
      app.showModal({
        content: '已经加载到最后了'
      });
    }
    if (compData.loading || !compData.is_more) {
      return;
    }
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);

    param.page_size = customFeature.loadingNum || 20;
    param.page = curpage;

    app.sendRequest({
      url: '/index.php?r=AppVideo/GetVideoList',
      data: param,
      method: 'post',
      hideLoading: true,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        let rdata = res.data;

        for (let i = 0; i < rdata.length; i++) {
          rdata[i].video_view = app.handlingNumber(rdata[i].video_view);
        }

        newdata = {};
        newdata['eles[' + compindex + '].video_data'] = compData.video_data.concat(rdata);
        newdata['eles[' + compindex + '].is_more'] = res.is_more;
        newdata['eles[' + compindex + '].curpage'] = res.current_page;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;

        pageInstance.setData(newdata);
      },
      fail: function () {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      complete: function () {
      }
    })
  }

  turnToVideoDetail = (e) => {
    app.turnToVideoDetail(e);
  }

  _refreshVideoList = (targetCompIndex, requestData, pageInstance) => {
    let _this = this;

    requestData.page_size = requestData.page_size || pageInstance.data.eles[targetCompIndex].customFeature.loadingNum || 10;
    if (requestData.idx_arr['idx'] === 'category') {
      requestData.cate_id = requestData.idx_arr['idx_value'];
    }

    let newdata = {};
    newdata['eles[' + targetCompIndex + '].loading'] = true;
    newdata['eles[' + targetCompIndex + '].loadingFail'] = false;
    newdata['eles[' + targetCompIndex + '].video_data'] = [];
    newdata['eles[' + targetCompIndex + '].is_more'] = 1;
    newdata['eles[' + targetCompIndex + '].curpage'] = 0;
    newdata['eles[' + targetCompIndex + '].param'] = requestData;
    pageInstance.setData(newdata);

    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppVideo/GetVideoList',
      data: requestData,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        if (res.status == 0) {
          let rdata = res.data,
            newdata = {};

          for (let i = 0; i < rdata.length; i++) {
            rdata[i].video_view = app.handlingNumber(rdata[i].video_view);
          }

          newdata['eles[' + targetCompIndex + '].video_data'] = rdata;

          newdata['eles[' + targetCompIndex + '].is_more'] = res.is_more;
          newdata['eles[' + targetCompIndex + '].curpage'] = 1;
          newdata['eles[' + targetCompIndex + '].loading'] = false;
          newdata['eles[' + targetCompIndex + '].loadingFail'] = false;

          pageInstance.setData(newdata);
        }
      },
      fail: function (res) {
        let newdata = {};
        newdata['eles[' + targetCompIndex + '].loadingFail'] = true;
        newdata['eles[' + targetCompIndex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  }

  render() {
    const data = this.props.data;
    let {
      customFeature, style, video_data,
      title_width
    } = this.props.data;
    // TODO 暂时拿不到title_width
    title_width = title_width || {width: ''}
    const {
      mode, hideRate, hidePlayCount,
      imgWidth, imgHeight, lineHeight,
      margin, lineBackgroundColor
    } = customFeature;
    const styleObj = convertStyleData(style);
    if (customFeature.vesselAutoheight == 0) {
      styleObj['height'] = transformPx2Rem(customFeature['height'], 320);
    }
    const listStyleObj = {
      marginBottom: transformPx2Rem(margin, 320),
      backgroundColor: lineBackgroundColor,
      height: transformPx2Rem(lineHeight, 320)
    };
    const imgStyleObj = {
      width: transformPx2Rem(imgWidth, 320),
      height: transformPx2Rem(imgHeight, 320)
    }

    const swiperStyleObj = {
      marginBottom: transformPx2Rem(margin, 320),
      height: transformPx2Rem(lineHeight, 320),
      backgroundColor: lineBackgroundColor
    };
    
    return <div className="custom-component video-list">
    <ScrollView
      className={`element video-list scroll-ele video-list-mode-${mode}`}
      style={styleObj}
      data-compindex={this.props.index}
      scroll-y="true"
      scroll-x="false"
      lower-threshold="100"
      bindscrolltolower={(e) => this.videoScrollFunc(e)}
      // bindanimationend="animationEnd"
      >
      <div className="js-list-container video-list-ul clearfix">
        {mode == 1 &&
          <React.Fragment>
            {video_data && video_data.map((item) => {
              return <div className="video-list-item clearfix"
                key={item.id}
                style={listStyleObj}
                data-id={item.id}
                onClick={this.turnToVideoDetail}>
                <div className="video-list-inner">
                  <div className="list-img-outer" style={imgStyleObj}>
                    <img className="list-img" src={item.preview_img} />
                    <div className="video-list-play icon-play ico-moon"></div>
                    {!hideRate && <label className="rate">{item.score}</label>}
                  </div>
                  <div className="title-container">
                    <div className="title">{item.title}</div>
                    {!hidePlayCount &&
                      <div className="play-count-outer">
                        <label className="video-eye ico-moon icon-eye"></label>
                        <label className="play-count">{item.video_view}</label>
                      </div>
                    }
                    {item.is_free == '0' && <div className="price"><label className="rmb">¥</label>{item.price}</div>}
                    {item.is_free != '0' && <div className="price">免费</div>}
                  </div>
                </div>
              </div>
            })}
          </React.Fragment>
        }
        {mode == 3 &&
          <React.Fragment>
            <Carousel
              autoplay={false}
              dots={false}
              infinite
              style={swiperStyleObj}
            >
              {video_data && video_data.map(item => (
                <div className="video-list-item" key={item.id} style={listStyleObj}>
                  <div className="video-list-inner">
                    <div className="list-img-outer" style={imgStyleObj}>
                      <img className="list-img" src={item.preview_img} />
                      <div className="video-list-play icon-play ico-moon"></div>
                      {!hideRate && <label className="rate">{item.score}</label>}
                    </div>
                    <div className="title-container" style={{ width: mode == 0 ? title_width.width : 'auto' }}>
                      <div className="title">{item.title}</div>
                      {item.is_free == '0' && <div className="price"><label className="rmb">¥</label>{item.price}</div>}
                      {item.is_free != '0' && <div className="price">免费</div>}
                      {!hidePlayCount &&
                        <div className="play-count-outer">
                          <label className="video-eye ico-moon icon-eye"></label>
                          <label className="play-count">{item.video_view}</label>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              ))}
            </Carousel>
          </React.Fragment>
        }
        {mode != 1 && mode != 3 &&
          <React.Fragment>
            {video_data && video_data.map(item => {
              return <div className="video-list-item clearfix"
                key={item.id}
                style={listStyleObj}
                data-id={item.id}
                onClick={this.turnToVideoDetail}>
                <div className="video-list-inner">
                  <div className="list-img-outer">
                    <img className="list-img" src={item.preview_img} style={imgStyleObj} />
                    <div className="video-list-play icon-play ico-moon"></div>
                  </div>
                  <div className="title-container" style={{ width: mode == 0 ? title_width.width : 'auto' }}>
                    <div className="title">{item.title}</div>
                    <div className="video-list-score">
                      {!hideRate &&
                        <div className="video-score-wrap">
                          <div className="numeric">
                            <label className="star ico-moon icon-score"></label>
                            <label className="star ico-moon icon-score"></label>
                            <label className="star ico-moon icon-score"></label>
                            <label className="star ico-moon icon-score"></label>
                            <label className="star ico-moon icon-score"></label>
                          </div>
                          <div className="numeric numeric-top" style={{ width: item.score * 10 + '%' }}>
                            <label className="star full-star ico-moon icon-score"></label>
                            <label className="star full-star ico-moon icon-score"></label>
                            <label className="star full-star ico-moon icon-score"></label>
                            <label className="star full-star ico-moon icon-score"></label>
                            <label className="star full-star ico-moon icon-score"></label>
                          </div>
                        </div>
                      }
                      {!hideRate && <label className="rate">{item.score}</label>}
                      {!hidePlayCount && <label className="video-eye ico-moon icon-eye"></label>}
                      {!hidePlayCount && <label className="play-count">{item.video_view}</label>}
                    </div>
                    {item.is_free == '0' && <div className="price"><label className="rmb">¥</label>{item.price}</div>}
                    {item.is_free != '0' && <div className="price">免费</div>}
                  </div>
                </div>
              </div>
            })}
          </React.Fragment>
        }
      </div>
      {
        customFeature.mode != 3 && (
          <React.Fragment>
            {/* 加载loading */}
            {
              data.loading && 
              <RequestStatus is="requestLoading"></RequestStatus>
            }
            {/* 加载没有数据 */}
            {
              data.is_more == 0 && data.video_data.length == 0 &&
              <RequestStatus is="requestNone" data={{ data: '暂无视频~'}}></RequestStatus>
            }
            {/* 加载失败 */}
            {
              data.loadingFail &&
              <RequestStatus is="requestFail" data={{refreshEvent: 'videoScrollFunc', compindex: this.props.index}}></RequestStatus>
            }
            {/* 加载完所有数据 */}
            {
              data.is_more == 0 && data.video_data.length > 0 && data.customFeature.isShowFinishText &&
              <RequestStatus is="requestAll"></RequestStatus>
            }
            {/* 点击加载按钮 */}
            {
              data.customFeature.vesselAutoheight == 1 && data.customFeature.loadingMethod == 1 && data.customFeature.mode != 2 && !!data.is_more && data.is_more != 0 && !data.loading && !data.loadingFail &&
              <LoadingBtn customFeature={customFeature} onClick={this.videoScrollFunc} data-compindex={this.props.index}></LoadingBtn>
            }
          </React.Fragment>
        )
      }
    </ScrollView>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/custom-component/video-list-custom-component/VideoListCustomComponent.jsx